import React from 'react';
import JavascriptHome from './JavascriptHome.jsx';
import JavascriptIntroduction from './JavascriptIntroduction.jsx';
import JavascriptWhereTo from './JavascriptWhereTo.jsx';
import JavascriptOutput from './JavascriptOutput.jsx';
import JavascriptSyntax from './JavascriptSyntax.jsx';
import JavascriptStatements from './JavascriptStatements.jsx';
import JavascriptComments from './JavascriptComments.jsx';
import JavascriptVariables from './JavascriptVariables.jsx';
import JavascriptLet from './JavascriptLet.jsx';
import JavascriptConst from './JavascriptConst.jsx';
import JavascriptOperators from './JavascriptOperators.jsx';
import JavascriptArithmetic from './JavascriptArithmetic.jsx';
import JavascriptAssignment from './JavascriptAssignment.jsx';
import JavascriptFunctions from './JavascriptFunctions.jsx';
import JavascriptObjects from './JavascriptObjects.jsx';
import JavascriptEvents from './JavascriptEvents.jsx';
import JavascriptStrings from './JavascriptStrings.jsx';
import JavascriptStringTemplates from './JavascriptStringTemplates.jsx';
import JavascriptNumbers from './JavascriptNumbers.jsx';
import JavascriptArrays from './JavascriptArrays.jsx';
import JavascriptDates from './JavascriptDates.jsx';
import JavascriptMath from './JavascriptMath.jsx';
import JavascriptBooleans from './JavascriptBooleans.jsx';
import JavascriptComparisons from './JavascriptComparisons.jsx';
import JavascriptLogical from './JavascriptLogical.jsx';
import JavascriptIfElse from './JavascriptIfElse.jsx';
import JavascriptSwitch from './JavascriptSwitch.jsx';
import JavascriptLoops from './JavascriptLoops.jsx';
import JavascriptBreak from './JavascriptBreak.jsx';
import JavascriptContinue from './JavascriptContinue.jsx';
import JavascriptErrors from './JavascriptErrors.jsx';
import JavascriptScope from './JavascriptScope.jsx';
import JavascriptCodeBlocks from './JavascriptCodeBlocks.jsx';
import JavascriptUtf8 from './JavascriptUtf8.jsx';
import JavascriptNews from './JavascriptNews.jsx';

export default function JsTutorial() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Tutorial</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/home' className='underline'>JS Home</a></li>
<li><a href='/javascript/introduction' className='underline'>JS Introduction</a></li>
<li><a href='/javascript/where-to' className='underline'>JS Where To</a></li>
<li><a href='/javascript/output' className='underline'>JS Output</a></li>
<li><a href='/javascript/syntax' className='underline'>JS Syntax</a></li>
<li><a href='/javascript/statements' className='underline'>JS Statements</a></li>
<li><a href='/javascript/comments' className='underline'>JS Comments</a></li>
<li><a href='/javascript/variables' className='underline'>JS Variables</a></li>
<li><a href='/javascript/let' className='underline'>JS Let</a></li>
<li><a href='/javascript/const' className='underline'>JS Const</a></li>
<li><a href='/javascript/operators' className='underline'>JS Operators</a></li>
<li><a href='/javascript/arithmetic' className='underline'>JS Arithmetic</a></li>
<li><a href='/javascript/assignment' className='underline'>JS Assignment</a></li>
<li><a href='/javascript/functions' className='underline'>JS Functions</a></li>
<li><a href='/javascript/objects' className='underline'>JS Objects</a></li>
<li><a href='/javascript/events' className='underline'>JS Events</a></li>
<li><a href='/javascript/strings' className='underline'>JS Strings</a></li>
<li><a href='/javascript/string-templates' className='underline'>JS String Templates</a></li>
<li><a href='/javascript/numbers' className='underline'>JS Numbers</a></li>
<li><a href='/javascript/arrays' className='underline'>JS Arrays</a></li>
<li><a href='/javascript/dates' className='underline'>JS Dates</a></li>
<li><a href='/javascript/math' className='underline'>JS Math</a></li>
<li><a href='/javascript/booleans' className='underline'>JS Booleans</a></li>
<li><a href='/javascript/comparisons' className='underline'>JS Comparisons</a></li>
<li><a href='/javascript/logical' className='underline'>JS Logical</a></li>
<li><a href='/javascript/if-else' className='underline'>JS If Else</a></li>
<li><a href='/javascript/switch' className='underline'>JS Switch</a></li>
<li><a href='/javascript/loops' className='underline'>JS Loops</a></li>
<li><a href='/javascript/break' className='underline'>JS Break</a></li>
<li><a href='/javascript/continue' className='underline'>JS Continue</a></li>
<li><a href='/javascript/errors' className='underline'>JS Errors</a></li>
<li><a href='/javascript/scope' className='underline'>JS Scope</a></li>
<li><a href='/javascript/code-blocks' className='underline'>JS Code Blocks</a></li>
<li><a href='/javascript/utf8' className='underline'>JS UTF-8 Characters</a></li>
<li><a href='/javascript/news' className='underline'>JS News 2025-2015</a></li>
      </ul>
    </div>
  );
}
